$(document).ready(function() {

	resizeIFrame();

	$(window).resize( function() {
		resizeIFrame();
	});

	function resizeIFrame() {

		if( $('iframe').length > 0 ){
		    $('iframe').each(function(){
		        var width = Math.ceil($(this).parent().width());
		        var height = Math.ceil(width * 0.6093);
		        $(this).css({
		        	height: height + 'px',
		        	width: width + 'px'
				});
		    });
		}
	}
});